module.exports = __webpack_public_path__ + "static/media/fundis-success-story-quote.a017d78d.webp";